<div>
    <div class="breadcrumb-block">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="{ name:'business-dashboard'}">Home</router-link>
                </li>
                <li aria-current="page" class="breadcrumb-item active">
                    Manage Booking
                </li>
            </ol>
        </nav>
    </div>
    <FlashMessage></FlashMessage>
    <div class="white-box pb-0">
        <div class="error-list modal-dialog-centeredmx-2" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p> {{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="sort-wrapper">
            <div class="row">
                <div @click.prevent="toggleFilter" class="col-lg-6">
                    <a aria-controls="collapseExample" aria-expanded="false" class="filter-head" role="button">
                        <i class="fas fa-filter"></i> Show Filter
                    </a>
                </div>
                <div class="col-lg-6">
                    <div @click="clearAllFilter" class="clear text-right">
                        <a class="filter-head">
                            <i class="fas fa-redo"></i> clear all filters
                        </a>
                    </div>
                </div>
            </div>
            <div class="collapse filter-body">
                <form action="#">
                    <div class="form-modified">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="Package title">Booking type</label>
                                    <div class="multiselect-input">
                                        <multiselect :options='item.bookingTypeList' :track-by="'id'"
                                                     @input="getBookingByFilter()"
                                                     label="name"
                                                     placeholder="Choose booking type.."
                                                     v-model="searchData.bookingType"></multiselect>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="Package title">Trek</label>
                                    <div class="multiselect-input">
                                        <multiselect :options='item.trekList'
                                                     :track-by="'id'"
                                                     @input="getDepartureList()"
                                                     label="title" placeholder="Choose Trek.."
                                                     v-model="searchData.trek">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-lg-4" v-if="!TrekStatusDisable">
                            <div class="form-group">
                              <label for="Package title">Trek</label>
                              <div class="multiselect-input" v-if="StatusList">
                                <multiselect :options='TrekList' label="title" :track-by="'id'" v-model="GetTrek"
                                  @input="getDepartureList()"  placeholder="Choose Trek.."></multiselect>
                              </div>
                            </div>
                          </div> -->
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="Package title">Departure</label>
                                    <div class="multiselect-input" v-if="item.filterDepartureList">
                                        <multiselect :options='item.filterDepartureList' :track-by="'id'"
                                                     @input="getBookingByFilter()"
                                                     label="start_date" placeholder="Choose Departure.."
                                                     v-model="searchData.departureDate">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="advance-filter">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Customer name</label>
                                        <input @keyup="getBookingByFilter()" class="form-control"
                                               placeholder="Enter customer name"
                                               type="text"
                                               v-model="searchData.name">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Customer phone number</label>
                                        <input @keyup="getBookingByFilter()" class="form-control"
                                               placeholder="Enter customer name"
                                               type="text"
                                               v-model="searchData.number">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Customer email</label>
                                        <input @keyup="getBookingByFilter()" class="form-control"
                                               placeholder="Enter customer email address"
                                               type="text" v-model="searchData.email">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Payment method</label>
                                        <div class="multiselect-input">
                                            <multiselect :options='item.paymentMethodList' :track-by="'name'"
                                                         @input="getBookingByFilter()"
                                                         label="name" placeholder="Choose payment method"
                                                         v-model="searchData.payment">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <label for="Package title">Payment date between</label>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="input-group attached-date">
                                                <datetime @input="getBookingByFilter()" format="yyyy-MM-dd"
                                                          placeholder="Start Date"
                                                          v-model="searchData.startDate"></datetime>
                                                <div class="input-group-append attached-label"><span
                                                        class="input-group-text"
                                                        id="basic-addon1">Start date</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="input-group attached-date">
                                                <datetime @input="getBookingByFilter()" format="yyyy-MM-dd"
                                                          placeholder="End Date"
                                                          v-model="searchData.endDate"></datetime>
                                                <div class="input-group-append attached-label"><span
                                                        class="input-group-text"
                                                        id="basic-addon1">End date</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Payment status</label>
                                        <div class="multiselect-input">
                                            <multiselect :options='item.paymentStatusList' :track-by="'id'"
                                                         @input="getBookingByFilter()"
                                                         label="name" placeholder="Choose payment status"
                                                         v-model="searchData.paymentStatus"></multiselect>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <a @click.prevent="openAdvanceFilter" class="advance-filter-btn"><i class="fas fa-search"></i>
                            Advance
                            filter</a>

                    </div>

                </form>
            </div>

            <hr>
        </div>

        <div class="table-title">
            <div class="container-fluid px-0">
                <div class="row align-items-center">
                    <div class="col-lg-10">
                        <h5>Manage booking</h5>
                    </div>
                    <!-- <div class="col-lg-2">
                      <a class="btn add-btn" href="#" @click.prevent="departureModal()"><i class="fas fa-plus"></i> Add New
                        Departure</a>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="manage-booking-table">
            <div class="table-container">
                <div class="table-responsive">
                    <table class="table" id="example">
                        <thead class="table-light-bg">
                        <tr>
                            <th>Trek title
                                <!-- <i class="fas fa-chevron-up"></i>
                                <i class="fas fa-chevron-down"></i> -->
                            </th>
                            <th scope="col">Departure date
                                <!-- <i class="fas fa-chevron-up"></i>
                                <i class="fas fa-chevron-down"></i> -->
                            </th>
                            <th scope="col">Start time
                                <!-- <i class="fas fa-chevron-up"></i>
                                <i class="fas fa-chevron-down"></i> -->
                            </th>
                            <th scope="col">
                                Booking type

                            </th>
                            <th scope="col">
                                Payment status
                                <!-- <i class="fas fa-chevron-down"></i> -->
                            </th>
                            <th scope="col">
                                Payment date

                                <!-- <i class="fas fa-chevron-down"></i> -->
                            </th>
                            <th scope="col">
                                Total cost
                                <!-- <i class="fas fa-chevron-down"></i> -->
                            </th>

                            <th scope="col">
                                Action
                            </th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" class="booking-detail-row" v-for="(item, index) in item.bookingList">
                            <td v-if="item.trek">{{item.trek.title}}</td>
                            <td v-else>-</td>
                            <td v-if="item.departure">{{item.departure.start_date}}</td>
                            <td v-else>-</td>
                            <td v-if="item.departure">{{item.departure.start_time}}</td>
                            <td v-else>-</td>
                            <td v-if="item">{{item.type}}</td>
                            <td v-else>-</td>
                            <td v-if="!item.is_paid"><span class="badge badge-danger">Not Paid</span></td>
                            <td v-else><span class="badge badge-success">Paid</span></td>
                            <td v-if="item.paid_date">{{item.paid_date}}</td>
                            <td v-else>No Date</td>
                            <td v-if="item.total_price">

                                <strong class="badge badge-primary">{{item.total_price}}</strong>

                            </td>
                            <td v-else>-</td>
                            <td>
                                <div class="justify-content-start">
                                    <!-- <a class="btn default-btn green shrink-btn" @click.prevent="shrinkTable(item, index)">
                                      Quick details
                                    </a> -->
                                    <button @click.prevent='viewDetail(index, item)' class="btn blue" type="button">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>


                        </tbody>
                    </table>
                    <div class="empty-data" v-if="item.bookingList ==0">
                        <p>
                            No Booking List
                        </p>
                    </div>
                    <div class="spinner">
                        <moon-loader :loading="ui.status.isLoadingFilter" :size="50" v-if="item.bookingList"></moon-loader>
                    </div>
                </div>

            </div>
            <Pager :pager="ui.paging" @onPaging="onPaging"></Pager>
        </div>

    </div>
</div>
